module.exports = __webpack_public_path__ + "img/logitech_quiz.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/views/partials/quiz_type/archive/img/logitech_quiz.jpg
// module id = 90
// module chunks = 0